<template>
    <div class="sub-page">
        <el-breadcrumb separator="/">
            <i class="el-icon-location"></i>
            <el-breadcrumb-item :to="{ path: '/index/member' }">服务人员</el-breadcrumb-item>
            <el-breadcrumb-item>导入人员</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="form-box">
            <div class="step-box">
                <el-steps :active="activeStep" :align-center="true">
                    <el-step title="提交数据" description=""></el-step>
                    <el-step title="确认数据" description=""></el-step>
                    <el-step title="导入成功" description=""></el-step>
                </el-steps>
            </div>
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Import',
    data () {
        return {
            activeStep: 1
        }
    },
    mounted () {
        this.indexWatch()
    },
    watch: {
        '$route': 'indexWatch'
    },
    methods: {
        indexWatch () {
            if (this.$route.path.substr(-1, 1) * 1 === 2) {
                this.activeStep = 2
            } else if (this.$route.path.substr(-1, 1) * 1 === 3) {
                this.activeStep = 3
            } else {
                this.activeStep = 1
            }
        }
    }
}
</script>

<style scoped lang="scss">
    @import "../../assets/style/sub.scss";
    .data-overview {
        height: 78px;
    }
</style>
